import * as ActionTypes from '../../actions/allActions'

const initialState = { errorMessage: '', localisedErrorMessage: '', showErrorModal: false }
const appErrors = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.BACKEND_ERROR:
			return { ...state, errorMessage: action.error, showErrorModal: true }
		case ActionTypes.LOCALISED_ERROR:
			return { ...state, errorMessage: "", localisedErrorMessage: action.error, showErrorModal: true }
		case ActionTypes.BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER_SUCCESS:
			if(!action.data.sodexo_reference_exists){
				return { ...state, errorMessage: 'error_wrong_worker_sodexo_number', showErrorModal: true }
			}
			return state
		case ActionTypes.CLOSE_ERRORMODAL:
			return { ...state, showErrorModal: false }
		case ActionTypes.LOGOUT:
			return initialState
		default:
			return state
	}
}

export default appErrors



// WEBPACK FOOTER //
// ./src/reducers/data/appErrors.js